import { Injectable, inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IMessagePageDetails } from '../../interfaces/message/message-page-details';
import { SharedService } from '../shared.service';

@Injectable({
  providedIn: 'root'
})
export class MessagePageService {

  private readonly messagePageDetailsUrl: string = '/message-page-details/{messagePageUuid}';
  
  private readonly baseHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor(
    private readonly http: HttpClient,    
    private readonly sharedService: SharedService   
  ) { }

  // public getMessagePageDetails(region: string, moduleName: string, messagePageUuid: string): Observable<IMessagePageDetails> {
  //   let baseUrl = this.sharedService.getBaseUrlByRegion(region);
  //   console.log('messagePageUuid', messagePageUuid);
  //   if (moduleName != 'walletron') {
  //     baseUrl = baseUrl?.replace('Walletron/api', moduleName + '/api');
  //   }
  //   var url = baseUrl + this.messagePageDetailsUrl
  //     .replace('{messagePageUuid}', messagePageUuid);
  //   console.log('getMessagePageDetails - url', url);
  //   return this.http.get<IMessagePageDetails>(url, {headers: this.baseHeaders, responseType: 'json'})
  //   .pipe(
  //       map(response => {
  //         console.log('getMessagePageDetails service - response', response);
  //         let res: IMessagePageDetails = {
  //           messagePageId: response.messagePageId,
  //           messagePageUuid: response.messagePageUuid,
  //           brandCode: response.brandCode,
  //           messageCode: response.messageCode ?? response.messageCode,
  //           messageTemplateCode: response.messageTemplateCode ?? response.messageTemplateCode,
  //           messageText: response.messageText ?? response.messageText,
  //           status: response.status ?? response.status,
  //           kind: response.kind ?? response.kind,
  //           persisted: response.persisted ?? response.persisted,
  //           createDate: response.createDate,
  //           options: new Map<string, string>(Object.entries(response.options ?? {})) 
  //         };
  //         return res;
  //     }),
  //     catchError(this.sharedService.handleError)
  //   )
  // }


    public getMessagePageDetails(region: string,moduleName: string, messagePageUuid: string): Observable<IMessagePageDetails> {

      let baseUrl = this.sharedService.getBaseUrlByRegion(region);
      if (moduleName !== 'walletron') {
        baseUrl = baseUrl?.replace('Walletron/api', `${moduleName}/api`);
      }
      const url = baseUrl + this.messagePageDetailsUrl.replace('{messagePageUuid}', messagePageUuid);
      return this.http.get<IMessagePageDetails>(url, {headers: this.baseHeaders,responseType: 'json'})
      .pipe(
        map((response: IMessagePageDetails) => ({
          ...response,
          options: new Map<string, string>(Object.entries(response.options ?? {}))
        })),
        catchError(this.sharedService.handleError)
      );
    }



}
